import { render, staticRenderFns } from "./EnquirerDetails.vue?vue&type=template&id=801a88f0&scoped=true&"
import script from "./EnquirerDetails.vue?vue&type=script&lang=js&"
export * from "./EnquirerDetails.vue?vue&type=script&lang=js&"
import style0 from "./EnquirerDetails.vue?vue&type=style&index=0&id=801a88f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801a88f0",
  null
  
)

export default component.exports